import { createPortal } from "react-dom";

import closeIcon from "../../../images/close-icon.svg";
import {
  ClosePopupButton,
  ModalContent,
  ModalOverlay,
  ModalWrapper
} from "../../../styles/styles";
import { ensureModalRoot } from "./modalRoot";

const PortalModal = ({
  open = true,
  onClose,
  children,
  alignItems = "center",
  padding,
  contentWidth,
  showCloseButton = true,
  closeIconSrc = closeIcon,
  overlayProps = {},
  wrapperProps = {},
  contentProps = {},
  closeButtonProps = {},
  details
}) => {
  if (!open) return null;

  const modalRoot = ensureModalRoot();
  if (!modalRoot) return null;

  const handleClose = () => {
    onClose?.();
  };

  const overlayMergedProps = {
    alignItems,
    padding,
    ...overlayProps
  };

  const contentMergedProps = {
    ...(contentWidth ? { width: contentWidth } : {}),
    ...contentProps
  };

  return createPortal(
    <ModalOverlay {...overlayMergedProps} alignItems={details && "center"}>
      <ModalWrapper {...wrapperProps}>
        <ModalContent {...contentMergedProps}>
          {showCloseButton && (
            <ClosePopupButton
              src={closeIconSrc}
              onClick={handleClose}
              {...closeButtonProps}
            />
          )}
          {children}
        </ModalContent>
      </ModalWrapper>
    </ModalOverlay>,
    modalRoot
  );
};

export default PortalModal;

